import TemplateView from '../../../TemplateView'
import messageResource from '../../../messageResource'
import Button from "../../../components/Button";
export default class CreateProjectLightboxFooter extends TemplateView {

    constructor() {
        super(null)
    }

    templateHtml() {
        return '<div class="createLightBoxFooter">' +
               '    <div class="errorMessageBox">' +
               '        <div class="errorIcon"/>' +
               '        <span class="errormsg"><%-errorMsg%></span>' +
               '    </div>' +
               '    <div class="buttonsBox">' +
               '        <span class="changesMsg"><%-changesMsg%></span>' +
               '        <span class="savingMsg"><%-savingMsg%></span>' +
               '        <div class="commitButtonPlaceHolder"/> ' +
               '        <div class="greyButton cancelBtn"><%-cancelBtn%></div>' +
               '    </div>' +
               '</div>'
    }


    afterRender() {
        let title = messageResource.getMessage("customer.create.commit_button.text")
        if(title.length > 17) {
            title = messageResource.getMessage("customer.create.commit_button.default_text")
        }
        this.commitButton = new Button({
            label: title,
            withPlusIcon: true,
        }).init(this.find('.commitButtonPlaceHolder'))
    }

    messageKeys() {
        return {
            errorMsg: 'customer.edit.correct_errors',
            changesMsg: 'customer.edit.not_saved',
            savingMsg: 'customer.edit.saving',
            cancelBtn: 'customer.edit.cancel_button.text'
        }
    }

    getCommitBtnEl() {
        return this.commitButton.getEl();
    }

    getCancelBtnEl() {
        return this.find('.cancelBtn')
    }
}


// WEBPACK FOOTER //
// ./web/js/taskManagement/createLightbox/customer/Footer.js